import { Lock } from 'lucide-react';
import * as React from 'react';
import { Button, type ButtonProps } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';

/**
 * PermissionButton — ação negada não é ação escondida.
 *
 * Playbook § Acessibilidade: usuário sem permissão vê o controle desabilitado,
 * com cadeado e explicação em `title`/`aria-label`. O controle nunca some, para
 * o usuário entender que a ação existe e por que não pode executá-la.
 */
export function PermissionButton({
  permitido,
  motivo,
  children,
  ...props
}: ButtonProps & { permitido: boolean; motivo: string }) {
  if (permitido) return <Button {...props}>{children}</Button>;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        {/* O span mantém o tooltip acessível mesmo com o botão desabilitado. */}
        <span tabIndex={0} aria-label={motivo} className="inline-flex">
          <Button {...props} disabled aria-disabled="true" title={motivo} className="cursor-not-allowed">
            <Lock aria-hidden="true" />
            {children}
          </Button>
        </span>
      </TooltipTrigger>
      <TooltipContent>{motivo}</TooltipContent>
    </Tooltip>
  );
}

/** Versão de link/linha para a navegação bloqueada da sidebar. */
export function ItemBloqueado({ rotulo, motivo, icone }: { rotulo: string; motivo: string; icone: React.ReactNode }) {
  return (
    <span
      title={motivo}
      aria-disabled="true"
      className="flex cursor-not-allowed items-center gap-3 rounded-button px-3 py-2 text-body text-on-surface-muted"
    >
      {icone}
      <span className="flex-1 truncate">{rotulo}</span>
      <Lock className="size-3.5 shrink-0" aria-hidden="true" />
    </span>
  );
}
